<script setup></script>

<template>
  <router-view />
  <Toast />
  <Toast position="top-center" group="tc" />
  <Toast position="bottom-right" group="br" />
  <!-- 채팅 다이얼로그는 useChat이 true일 때만 표시 -->
  <ChatDialog v-if="layoutStore.useChat" />
</template>

<script setup>
import { useLayoutStore } from "@/stores/layout";
import { useAuthStore } from "@/stores/auth";
import ChatDialog from "@/components/ChatDialog.vue";
import { onMounted } from "vue";

const layoutStore = useLayoutStore();
const authStore = useAuthStore();

// 앱 시작 시 도메인 기반으로 tenantId 자동 설정
onMounted(async () => {
  try {
    // 도메인 기반으로 tenantId 설정
    const tenantId = await authStore.setTenantIdFromDomain();
    
    if (tenantId) {

    }
    
    // 도메인 매핑 정보 로깅
    const mappingInfo = await authStore.getDomainMappingInfo();
    
  } catch (error) {
    console.error('앱 시작 시 도메인 기반 설정 실패:', error);
  }
});
</script>